import React, { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Input, Button, Form } from 'antd';
import * as _ from 'lodash';
import { actions as appointmentActions } from 'store/appointment';
import { APPOINTMENT_STATUS } from 'constants/Appointment';
import './Instruction.scss';
import StoreState from 'models/store';
import { formRules } from 'helpers/formUtils';

const Instruction: FC<any> = props => {
  const dispatch = useDispatch();
  const { data, initValues, isEditAvailability } = props;
  const [isAdd, setIsAdd] = useState<any>();
  const originTime = new Date();

  const arrInstructions = data?.detail?.encounters[0]?.obs?.filter(item =>
    item?.display?.includes('INSTRUCTION'),
  );

  const [isEdit, setIsEdit] = useState<boolean>();
  const [i, setI] = useState<any>();
  const appointmentReducer = useSelector(
    (state: StoreState) => state.appointment,
  );
  const [isSubmit, setIsSubmit] = useState(false);
  const status = _.get(data, 'detail.detail.status', '');
  const onFinish = values => {
    setIsSubmit(true);
    const { instructions } = values;
    const paramsCreateInstructions = {
      concept: '6ddca7a8-8d6a-45a8-ab1b-743fc5c4058a',
      value: instructions,
      obsDatetime: originTime?.toISOString(),
      person: data?.detail?.uuidPerson,
      encounter: data?.detail?.encounters[0]?.uuid,
    };
    dispatch(
      appointmentActions.handleCreateInstructions(paramsCreateInstructions),
    );
  };

  const handleEdit = _.debounce(key => {
    setIsEdit(true);
    setI(key);
  }, 50);
  const handleCancel = _.debounce(key => {
    setIsEdit(false);
    setI(key);
  }, 50);

  const onEdit = values => {
    const { value } = values;
    const uuidInstructions = arrInstructions && arrInstructions[i]?.uuid;
    const paramsEditInstructions = {
      value,
    };

    dispatch(
      appointmentActions.handleEditInstructions({
        uuidInstructions,
        paramsEditInstructions,
      }),
    );
    setIsEdit(false);
  };

  useEffect(() => {
    if (
      isSubmit === true &&
      appointmentReducer?.isAddCreateInstructions === true
    ) {
      setIsAdd(false);
    }
  }, [appointmentReducer?.isAddCreateInstructions]);

  return (
    <div className="instruction-Contaier">
      <div className="instruction-content">
        <Row className="instruction-title">
          <span className="pl-6">Lời dặn bác sỹ</span>
        </Row>
        <hr />
        {initValues?.instructions?.length > 0 && initValues && <hr />}
        {initValues?.instructions?.length > 0 ? (
          initValues?.instructions?.map((item, key) => {
            return (
              <Row className="row-1" key={key}>
                <Col xs={24}>
                  <div className="instruction-section">
                    <Form onFinish={onEdit}>
                      <div className="instruction-section__title">
                        <div>
                          <span>Hướng dẫn {key + 1}</span>
                        </div>
                        <div>
                          {isEditAvailability &&
                            status !== APPOINTMENT_STATUS.WAITING_EXAMINATION &&
                            (isEdit && key === i ? (
                              <>
                                <Button
                                  className="btn-edit"
                                  onClick={() => handleCancel(key)}
                                >
                                  Hủy
                                </Button>
                                <Button className="btn-edit" htmlType="submit">
                                  Lưu
                                </Button>
                              </>
                            ) : (
                              <Button
                                className="btn-edit"
                                onClick={() => handleEdit(key)}
                              >
                                Sửa
                              </Button>
                            ))}
                        </div>
                      </div>
                      <div className="instruction-section__content">
                        <div className="instruction-section__content_inside">
                          {isEdit && key === i ? (
                            <Form.Item
                              className="form-item-appointment-detail m-0 p-0"
                              name="value"
                              preserve={false}
                              rules={formRules}
                              initialValue={item}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            <span className="text-have-color-#555555">
                              {item}
                            </span>
                          )}
                        </div>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            );
          })
        ) : (
          <Row className="row-1">
            <Col xs={24}>
              <div className="anamnesis-section">
                <div className="no-content">
                  <span className="no-content__text">Chưa có thông tin</span>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
      {isEditAvailability && (
        <div className="instruction-add-container">
          {isAdd ? (
            <Form onFinish={onFinish}>
              <div className="instruction-input-add">
                <Form.Item name="instructions" rules={formRules}>
                  <Input
                    size="large"
                    placeholder="Thêm hướng dẫn "
                    ref={input => input && input.focus()}
                  />
                </Form.Item>
              </div>
              <div className="instruction-action-add">
                <div className="btn-ok">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={appointmentReducer?.isLoadingCreateInstructions}
                  >
                    Lưu
                  </Button>
                </div>
                <div className="btn-cancel">
                  <a
                    className="no-underline"
                    href="#"
                    onClick={() => setIsAdd(!isAdd)}
                  >
                    <span className="btn-add-form-input">Hủy</span>
                  </a>
                </div>
              </div>
            </Form>
          ) : (
            <div>
              <Button
                className="rounded-md"
                type="primary"
                onClick={() => setIsAdd(!isAdd)}
              >
                Thêm thông tin
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Instruction;
